<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
  </div>

  <div class="bisual-table">
    <form class="card paginator" [formGroup]="filterForm">
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="pageIndex"
        (page)="changePage($event)"
        style="margin-right: auto"
      ></mat-paginator>

      <mat-form-field class="bisual-paginator-select">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="status">
          @for (status_option of status_filter_options; track status_option.value) {
            <mat-option [value]="status_option.value">{{ status_option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <input matInput type="text" formControlName="search" placeholder="Buscar..." />
        <button matSuffix mat-icon-button aria-label="Buscar" type="button">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>Empleado</th>
          <td mat-cell *matCellDef="let element">{{ element.user_full_name }}</td>
        </ng-container>

        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Título</th>
          <td mat-cell *matCellDef="let element">
            <span [matTooltip]="element.title.length > 40 ? element.title : null">
              {{ element.title }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Precio</th>
          <td mat-cell *matCellDef="let element">{{ element.price }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">{{ element.status_label }}</td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button type="button" matTooltip="Ver solicitud" aria-label="Ver solicitud" (click)="openReviewDialog(element)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
